import { render, staticRenderFns } from "./TrAlterPay.vue?vue&type=template&id=5ab69396&scoped=true&"
import script from "./TrAlterPay.vue?vue&type=script&lang=js&"
export * from "./TrAlterPay.vue?vue&type=script&lang=js&"
import style0 from "./TrAlterPay.vue?vue&type=style&index=0&id=5ab69396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab69396",
  null
  
)

export default component.exports